import { render, staticRenderFns } from "./ConfigVue.vue?vue&type=template&id=59631d91&scoped=true&"
import script from "./ConfigVue.vue?vue&type=script&lang=js&"
export * from "./ConfigVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59631d91",
  null
  
)

export default component.exports